import Modal from "../../../components/Modal";
import { CATS_PAGAR, CATS_RECEBER } from "../constants";

export default function ModalConta({
  aba, modalForm, form, setF, salvando, salvarConta, onFechar, STATUS, clientes, fornecedores,
}) {
  if (!modalForm) return null;

  const footer = (
    <>
      <button className="btn btn-secondary" onClick={onFechar}>Cancelar</button>
      <button className="btn btn-primary" onClick={salvarConta} disabled={salvando}>{salvando?"Salvando...":"Salvar"}</button>
    </>
  );

  return (
    <Modal title={modalForm==="novo"?(aba==="pagar"?"Nova Conta a Pagar":"Nova Conta a Receber"):"Editar Conta"}
      onClose={onFechar} size="md" footer={footer}>
      <div className="form-grid">
        <div className="form-group" style={{gridColumn:"span 2"}}>
          <label className="form-label">Descricao</label>
          <input className="form-input" value={form.descricao||""} onChange={e=>setF("descricao",e.target.value)}/>
        </div>
        <div className="form-group">
          <label className="form-label">Categoria</label>
          <select className="form-select" value={form.categoria||""} onChange={e=>setF("categoria",e.target.value)}>
            {(aba==="pagar"?CATS_PAGAR:CATS_RECEBER).map(o=><option key={o.v} value={o.v}>{o.l}</option>)}
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">{aba==="pagar"?"Fornecedor":"Cliente"}</label>
          <select className="form-select" value={form[aba==="pagar"?"fornecedor":"cliente"]||""} onChange={e=>setF(aba==="pagar"?"fornecedor":"cliente",e.target.value)}>
            <option value="">-- Selecione --</option>
            {(aba==="pagar"?fornecedores:clientes).map(c=><option key={c.id} value={c.id}>{c.nome}</option>)}
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Valor (R$)</label>
          <input className="form-input" type="number" value={form.valor||""} onChange={e=>setF("valor",e.target.value)}/>
        </div>
        <div className="form-group">
          <label className="form-label">Data Vencimento</label>
          <input className="form-input" type="date" value={form.data_vencimento||""} onChange={e=>setF("data_vencimento",e.target.value)}/>
        </div>
        <div className="form-group">
          <label className="form-label">Status</label>
          <select className="form-select" value={form.status||""} onChange={e=>setF("status",e.target.value)}>
            {Object.entries(STATUS).map(([v,{l}])=><option key={v} value={v}>{l}</option>)}
          </select>
        </div>
      </div>
      <div className="form-group">
        <label className="form-label">Observacoes</label>
        <textarea className="form-input" rows={2} value={form.observacoes||""} onChange={e=>setF("observacoes",e.target.value)}/>
      </div>
    </Modal>
  );
}
